import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { IAttendee, IAuthAttendee } from '@sv/interfaces';
import { Router } from '@angular/router';
import { customApp } from '../../_configuration/configuration';
import { CustomAppService } from '../_content/customApp.service';
import { AuthService } from './auth.service';
import { TicketcodeAuthService } from './ticketcode-auth.service';

@Injectable({
  providedIn: 'root'
})
export class AttendeesService {
  constructor(
    private http: HttpClient,
    private router: Router,
    private customAppService: CustomAppService,
    private ticketcodeAuthService: TicketcodeAuthService
  ) {}
  private attendeeListener = new Subject<IAttendee>();
  private oldAttendeeListener = new Subject<IAuthAttendee>();
  private authAttendee: IAuthAttendee;

  register(name: string, surname: string, email: string, additonalFields: { key: string; value: string }[], password?: string) {
    const subject = new Subject<{ message: string; data: any }>();

    this.customAppService.getCustomAppListener().subscribe((app) => {
      let attendee: IAttendee;
      if (password) {
        attendee = { name, surname, email, checkedin: false, eventId: app.eventId, attributes: additonalFields, password };
      } else {
        attendee = { name, surname, email, checkedin: false, eventId: app.eventId, attributes: additonalFields };
      }

      this.http.post<{ message: string; data: IAttendee }>(customApp.url + '/app/event/register', attendee).subscribe(
        (res) => {
          subject.next(res);
        },
        (error) => {
          subject.next({ message: 'error', data: error.error.message });
        }
      );
    });

    return subject;
  }

  registerWithoutTicketcode(name: string, surname: string, email: string, additonalFields: { key: string; value: string }[]) {
    const subject = new Subject<{ message: string; data: any }>();

    this.customAppService.getCustomAppListener().subscribe((app) => {
      const attendee: IAttendee = { name, surname, email, checkedin: false, eventId: app.eventId, attributes: additonalFields };

      this.http.post<{ message: string; data: IAttendee }>(customApp.url + '/app/event/withoutTicketCode', attendee).subscribe(
        (res) => {
          subject.next(res);
        },
        (error) => {
          subject.next({ message: 'error', data: error.error.message });
        }
      );
    });

    return subject;
  }

  login(email: string, ticketcode: string) {
    const authAttendee: IAuthAttendee = { email, ticketcode };
    this.http.post<{ message: string }>('http://localhost:3000/api/app/attendee/login', authAttendee).subscribe((response) => {
      this.authAttendee = authAttendee;
      this.oldAttendeeListener.next(this.authAttendee);
      this.router.navigate(['/']);
    });
  }

  async updateAttendeeActivation(email: string, eventId: string, token: string) {
    this.ticketcodeAuthService.setToken(token);
    const result = await this.http
      .post<{ status: string; error? }>(customApp.url + '/app/activate', { email, eventId, token })
      .toPromise();
    if (result.status === 'error') {
      console.log(result.error);
      return false;
    } else {
      return true;
    }
  }

  async recordUserConsent(attendeeId: string) {
    const result = await this.http
      .post<{ status: string; error? }>(customApp.url + '/app/event/tradeFair/gdpr-agreeTime', {
        timestamp: Date.now(),
        id: attendeeId
      })
      .toPromise();
    if (result.status === 'error') {
      console.log(result.error);
      localStorage.setItem('dataUsage', 'false');
    }
  }

  async resetPasswordEmail(email: string, eventId: string): Promise<void> {
    const result = await this.http
      .post<{ status: string; error?: any }>(customApp.url + '/app/event/resetPasswordEmail', {
        email,
        eventId
      })
      .toPromise();
    if (result.status === 'error') {
      console.log(result.error);
    }
  }

  async resetPassword(pw: string, token: string): Promise<void> {
    this.ticketcodeAuthService.setToken(token);
    const result = await this.http
      .post<{ status: string; error?: any }>(customApp.url + '/app/event/resetPassword', {
        pw
      })
      .toPromise();
    if (result.status === 'error') {
      console.log(result.error);
    }
  }

  getAttendeeListener() {
    return this.attendeeListener.asObservable();
  }

  getAuthAttendeeListener() {
    return this.oldAttendeeListener.asObservable();
  }
}
